/**
 * loginErrorState — when the login form should surface an error message.
 *
 * The `<p class="login-error">` is always in the DOM (its `--hidden` variant is color:transparent, so it
 * reserves its line and there is NO layout shift when an error appears). This decides ONLY visibility.
 *
 * Show an error ONLY for a real auth-failure result AND only when NOT mid-submit: while a new login is in
 * flight (`loading`), the PREVIOUS attempt's error must not linger — otherwise the user presses Login and
 * still sees "Access Denied" from last time until the new result lands (David 2026-08-14).
 */
export const LOGIN_ERROR_RESULTS = ['noauth', 'loginerror', 'invalidcreds'];

// Non-error NOTICES shown in the same message line (styled distinctly, not coral). 'pwchanged'
// = a cloud forced-password-change succeeded but the auto re-login didn't take, so the login
// form asks the user to sign in with their NEW password. (#86bbqnzhp)
export const LOGIN_NOTICE_RESULTS = ['pwchanged'];

export const shouldShowLoginError = (loginResult, loading) =>
  !loading && (LOGIN_ERROR_RESULTS.includes(loginResult) || LOGIN_NOTICE_RESULTS.includes(loginResult));

export default shouldShowLoginError;
